import { useEffect, useState } from "react";
import BannerLogo from "../../assets/Images/headerImg.svg";
import { HomeString } from "../../utils/string";
import SimilarCard from "../details/similarCard";
import Card from "../home/card/card";
import { ApplicationId } from "../../api/url";
import { postMachinesList } from "../../services/FeaturedListings";
import NoMachineAvailable from "../home/noMachineAvailable";
import SimilarCardSkeleton from "../loader/skeleton/similarCardSkeleton";
const SimilarMachines = ({ data }) => {
  const [relatedPostData, setRelatedPostData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (data) {
      GetRelatedPostsList(data?.category?.machine_type_id);
    }
  }, [data]);

  const GetRelatedPostsList = (ID) => {
    setIsLoading(true);
    let payload = {
      AssetTypeId: ID,
      CategoryId: data?.categorization?.category?.id,
      PageSize: 3,
      PageNumber: 1,
      IsLatestFirst: true,
      ApplicationId: ApplicationId,
    };
    postMachinesList(payload)
      .then((res) => {
        let filterMachinesList = res?.data?.machines?.filter(
          (item) => item?.assetAdvertisementId !== data?.assetAdvertisementId
        );
        setRelatedPostData(filterMachinesList);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  };
  return (
    <>
      <div className="bg-[#F2F2F2]">
        <div className="custom-container">
          <div className="text-[28px] md:text-[35px] font-bold text-center pt-[18px] mb-[24px] text-[#161412] uppercase">
            {HomeString.Similar_Machines}
          </div>

          <div className="max-w-[1024px] mx-auto py-[10px] pb-[43px]">
            <div className="grid grid-cols-4 gap-6 max-[1196px]:grid-cols-2 max-[842px]:grid-cols-1">
              {isLoading ? (
                [1, 2, 3, 4].map(() => {
                  return <SimilarCardSkeleton />;
                })
              ) : relatedPostData?.length <= 0 ? (
                <div
                  className="
                h-[500px] 
                flex 
                items-center 
                justify-center 
                max-[1196px]:col-span-2 
                max-[842px]:col-span-1 
                col-span-4"
                >
                  <NoMachineAvailable />
                </div>
              ) : (
                relatedPostData?.map((items) => {
                  return <SimilarCard data={items} listCard={true} />;
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SimilarMachines;
